import React from "react"
import { Wrapper } from "./media-text.style"

export const MediaText = ({ children, classList = [] }) => {
  return (
    <Wrapper className={classList.join(" ")}>
      {children}
    </Wrapper>
  )
}